<script>
// import axios from "axios";
import router from "@/router";
import Header from '@/components/front/Header';
import Footer from '@/components/front/Footer';

export default {
  page: {
    title: "Volunteer System",
    meta: [
      {
        name: "Volunteer System",
      },
    ],
  },
  components: {Header , Footer},
  data(){
    return{
      title: "",
      items: [
        {
          text: "",
          href: "/",
        },
      ],
      userData : JSON.parse(localStorage.getItem('web_user')),
      is_volunteer:false,
    }
  },
  methods:{
      gotomntcOrg(){
        window.open("https://www.mntc.org/");
      },
      gotoHomePage(){
        router.push({ name: 'volunteer-system'});
      }
  },
  mounted(){
    if(this.userData.user_type_id == 4){
      this.is_volunteer = true;
    }
  }

}
</script>

<template>
  <div>
    <Header></Header>
    <div id="main-title" class="secondary">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-6 align-self-center">
            <h3 class="title" > Thank You</h3>
          </div>
          <div class="col-12 col-lg-6 text-left text-lg-end align-self-center">
            <p class="need-help">Need Help ? <a href="javascript:">Contact Us</a> </p>
          </div>
        </div>
      </div>
    </div>
    <div id="create-account">
      <div class="container custom-form">
          <div class="row">
            <div class="col-12 mb-5">
              <h3 class="main-title">Application Submitted</h3>
            </div>
          </div>

        <!-- if volunteer -->
        <div v-if="is_volunteer" class="row modal-body" id = "mntc_thankyou_page_content">
            <div class="col-12">
            <p class="pb-0">Thank you for completing your application to become a MnTC volunteer. A member of our team will reach out to you via email.</p>
            <div class="d-flex justify-content-center mb-5">
                <b-button type="button" @click="gotoHomePage" variant="custom">Return to Homepage</b-button>
                <b-button type="button" @click="gotomntcOrg" variant="custom">Visit MNTC.ORG</b-button>
            </div>
            </div>
        </div>

        <!-- if mentor -->
        <div v-else class="row modal-body" id = "mntc_thankyou_page_content">
            <div class="col-12">
              <p>Thank you for completing your mentor application! Please check your email inbox for a confirmation email and complete the instructions. If you do not receive a confirmation email, check your junk/spam folder. We look forward to moving you forward in the process of becoming a mentor!</p>
            <!-- <p class="pb-0">Thank you for completing your application to become MNTC mentor. A member of our team will be reaching out to you directly if you are selected or if we need additional information.</p>
            <h4 class="fw-bold mb-3 mt-4">What to Expect?</h4>
            <p class="mt-2  pb-0">We will communicate acceptance or rejection of you application with X Business Days</p>
            <p class="mt-2  pb-0">We will be connecting with your references listed in the application</p>
            <p class="mt-2  pb-0">All applicants will be subject to a background check</p>
            <p class="mt-2  pb-0">If accepted, we will reach out to schedule orientation with the MNTC team</p> -->
            <div class="w-100 d-flex justify-content-center mb-5">
                <b-button type="button" @click="gotoHomePage" variant="custom">Return to Homepage</b-button>
                <b-button type="button" @click="gotomntcOrg" variant="custom">Visit MNTC.ORG</b-button>
            </div>
            </div>
        </div>

      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<style scoped>
    #mntc_thankyou_page_content p{
        font-size: 16px!important;
        text-align: center;
        text-transform: unset !important;
}

    #mntc_thankyou_page_content h4{
        color: #495057;
        font-size: 24px;
        text-align: center;
    }

</style>